import { getApplicationSettings } from 'owa-application-settings';

export function getRewardsPartnerId(): string {
    return getApplicationSettings('PlatformType').isMonarch ? 'OutlookMonarch' : 'OutlookOwa';
}
